<script setup>
import PlanningKeywordTable from '@frontJs/components/tables/projectManagement/sea/tenantReports/PlanningKeywordTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Planification - SEA - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - SEA - Planification </PageTitle>

    <PlanningKeywordTable />
</template>
